// ======================================================================
// File Name       : ServiceNoticeRegisterUserContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { Form } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import ServiceNoticeUserSearchDialog from '../../components/service/serviceNotification/ServiceNoticeUserSearchDialog';
import ServiceNoticeUserListDialog from '../../components/service/serviceNotification/ServiceNoticeUserListDialog';
import * as ServiceAction from '../../actions/ServiceAction';
import * as GroupAction from '../../actions/GroupAction';
import * as AuthorityAction from '../../actions/AuthorityAction';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../constants/index';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { USER_CREATE_TYPE, USER_TYPE } from '../../constants/UserConstants';
import { SERVICE_USER_TYPE, RELEASE_TARGET } from '../../constants/ServiceConstant';
import { checkUserChecked } from '../../utils/index';

class ServiceNoticeRegisterUserContainer extends React.Component {
  constructor(props) {
    super(props);
    this.addUsersToList = this.addUsersToList.bind(this);
    this.searchUser = this.searchUser.bind(this);
    this.searchUserOnSubmit = this.searchUserOnSubmit.bind(this);
    this.initData = this.initData.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
    this.checkUncheckAllUsersOnPage = this.checkUncheckAllUsersOnPage.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount() {
    const { userType } = this.props;
    this.initData(userType);
  }

  initData(userType) {
    const { authorityInfo } = this.props;
    const paramSearchInfo = {
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      userType,
    };
    const paramSearchAttribute = null;
    const emptyAuthorityInfo =
      !authorityInfo ||
      !authorityInfo.bySecernId ||
      !authorityInfo.managementAuthorityList ||
      !authorityInfo.managementAuthorityList.length;
    // Step 11.0.0 START
    if (userType === SERVICE_USER_TYPE.USAGE_SCREEN) {
      paramSearchInfo.userCreateType = USER_CREATE_TYPE.REPRESENTATIVE_USER;
    }
    // Step 11.0.0 END
    if (userType === SERVICE_USER_TYPE.USAGE_SCREEN && emptyAuthorityInfo) {
      this.props.dispatch(AuthorityAction.getAuthorityList()).then(() => {
        this.props
          .dispatch(ServiceAction.searchUserOnDialog({ paramSearchInfo, paramSearchAttribute }));
      });
    } else {
      this.props
        .dispatch(ServiceAction.searchUserOnDialog({ paramSearchInfo, paramSearchAttribute }));
    }
  }

  searchUser(startPosition) {
    const { formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const param = this.createParams(formValues, startPosition);
    const { paramSearchInfo, paramSearchAttribute } = param;
    this.props.dispatch(ServiceAction.searchUserOnDialog(param));
  }

  createParams(searchInfo, startPosition) {
    const { userType } = this.props;
    const paramSearchInfo = {};
    const paramSearchAttribute = {};
    paramSearchInfo.returnMaxNum = RETURN_MAX_NUM;
    paramSearchInfo.userType = userType;
    if (searchInfo && Object.keys(searchInfo).length) {
      searchInfo.loginId && (paramSearchInfo.loginId = searchInfo.loginId);
      searchInfo.userName && (paramSearchInfo.userName = searchInfo.userName);
      userType === SERVICE_USER_TYPE.USAGE_SCREEN &&
        searchInfo.managementAuthoritySecernId &&
        (paramSearchInfo.managementAuthorityList = [searchInfo.managementAuthoritySecernId]);
      paramSearchInfo.startPosition = searchInfo.startPosition || 0;

      searchInfo.userAttributeKeyNum &&
        (paramSearchAttribute.userAttributeKeyNum = searchInfo.userAttributeKeyNum);
      searchInfo.userAttributeSearchText &&
        (paramSearchAttribute.userAttributeSearchText = searchInfo.userAttributeSearchText);
    }
    if (!isNaN(parseInt(startPosition, 10))) {
      paramSearchInfo.startPosition = startPosition;
    }
    // Step 11.0.0 START
    if (userType === SERVICE_USER_TYPE.USAGE_SCREEN) {
      paramSearchInfo.userCreateType = USER_CREATE_TYPE.REPRESENTATIVE_USER;
    }
    // Step 11.0.0 END
    return { paramSearchInfo, paramSearchAttribute };
  }

  getStartEndData(startPosition) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchUser(startPosition);
  }

  searchUserOnSubmit(values) {
    const { invalid } = this.props;
    if (invalid || !values) {
      return;
    }
    const param = this.createParams(values, null);
    this.props.dispatch(ServiceAction.searchUserOnDialog(param));
  }

  addUsersToList() {
    const { edittingUserList, dispatch, hideModal } = this.props;
    // #6576 START
    const userChecked = checkUserChecked(edittingUserList);
    if (userChecked && userChecked.length === 0) {
      this.props.dispatch(change('serviceNoticeRegisterForm', 'edittingUserList', {}));
    }
    // #6576 END
    dispatch(ServiceAction.addUsersToList(userChecked));
    dispatch(hideModal());
  }

  checkUncheckAllUsersOnPage() {
    // #6576 START
    const { userList, initial, edittingUserList } = this.props;
    const userChecked = checkUserChecked(edittingUserList, userList);

    if (userList && userList.length) {
      userList.map((user) => {
        const { userSecernId } = user;
        if (userSecernId && edittingUserList && !edittingUserList[userSecernId]) {
          this.props.dispatch(change('serviceNoticeRegisterForm', `edittingUserList.${userSecernId}`, true));
        }
        if (edittingUserList && edittingUserList[userSecernId]) {
          if (userChecked.length === userList.length && !initial.edittingUserList[userSecernId]) {
            this.props.dispatch(change('serviceNoticeRegisterForm', `edittingUserList.${userSecernId}`, false));
          }
        }
      });
    }
    // #6576 END
  }

  closeModal() {
    const { initial: { edittingUserList } } = this.props;
    this.props.dispatch(change('serviceNoticeRegisterForm', 'edittingUserList', edittingUserList));
    this.props.dispatch(this.props.hideModal());
  }

  getModalOptions() {
    return {
      title: '',
      footerBtns: [
        { name: 'キャンセル', onClick: this.closeModal, variant: 'default' },
        {
          name: 'OK',
          onClick: this.addUsersToList,
          variant: 'primary',
        },
      ],
    };
  }

  render() {
    const {
      userListDialogRecordNum,
      userList,
      userType,
      authorityInfo,
      formValues,
      edittingUsers,
    } = this.props;
    return (
      <ModalWrapper temporaryHide={''} {...this.getModalOptions()} hideModal={this.closeModal}>
        <div>
          <Header name="メッセージを送信するユーザーを選択してください" />
          <ServiceNoticeUserSearchDialog
            {...formValues}
            onSearchBtnClick={this.searchUser}
            onSubmit={this.searchUserOnSubmit}
            recordNum={userListDialogRecordNum}
            getStartEndData={this.getStartEndData}
            userType={userType}
            authorityInfo={authorityInfo}
            checkUncheckAllUsersOnPage={this.checkUncheckAllUsersOnPage}
          />
          <ServiceNoticeUserListDialog userList={userList} edittingUsers={edittingUsers} />
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceNoticeRegisterForm } = state.form;
  const { authorityInfo } = state.authority;
  const { initial, values } = serviceNoticeRegisterForm;
  const { userList, userListDialogRecordNum, edittingUsers } = state.service;
  const { structures } = state.group;
  let edittingUserList = {};
  if (serviceNoticeRegisterForm && serviceNoticeRegisterForm.values
    && serviceNoticeRegisterForm.values.edittingUserList) {
    edittingUserList = serviceNoticeRegisterForm.values.edittingUserList;
  }
  return {
    userList,
    authorityInfo,
    edittingUserList,
    edittingUsers,
    serviceNoticeRegisterForm,
    userListDialogRecordNum,
    initial,
    values,
    formValues: getFormValues('searchServiceUserForm')(state),
    ...structures,
  };
};

export default connect(mapStateToProps)(ServiceNoticeRegisterUserContainer);
